import PropTypes from "prop-types";
import { useEffect, useRef } from "react";
import Highcharts from "highcharts/highstock";
import Loader from "../Loader";
import { initModule } from "../../utils/utility";
import createHighchartsOptions from "./HighChartsOptions";

import * as ExportingModule from "highcharts/modules/exporting";
import * as ExportDataModule from "highcharts/modules/export-data";
import NoData from "../Nodata";

// 3. Initialize
initModule(ExportingModule);
initModule(ExportDataModule);
function StepGraph(props) {
  const { data, loading } = props;
  const chartRef = useRef(null);
  const containerRef = useRef(null);
  const Title = "Connection status";

  useEffect(() => {
    if (!data || data.length === 0 || !containerRef.current) return;

    const chartData = data.map(item => ({
      x: item.ts,
      y: item.s,
      rsn: item.rsn,
    }));
    // Ensure chartData includes dateRange[0] and dateRange[1] points
    if (props.dateRange?.length === 2 && chartData?.length > 0) {
      // Convert to epoch if not already
      const toEpoch = val => {
        if (typeof val === "number") return val;
        // Try to parse as date string
        const d = new Date(val);
        return isNaN(d.getTime()) ? val : d.getTime();
      };
      const startEpoch = toEpoch(props.dateRange[0]);
      const endEpoch = toEpoch(props.dateRange[1]);
      // Add start point if not present
      if (chartData[0].x !== startEpoch) {
        chartData.unshift({ x: startEpoch, y: chartData[0].y, rsn: "" });
      }
      // Add end point if not present
      if (chartData[chartData.length - 1].x !== endEpoch) {
        chartData.push({ x: endEpoch, y: chartData[chartData.length - 1].y, rsn: "" });
      }
    }

    chartRef.current = Highcharts.stockChart(containerRef.current, createHighchartsOptions(Highcharts, chartData));

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
      }
    };
  }, [data]);

  return (
    <div className="relative w-full" style={{ height: "30%" }}>
      <div style={{ color: "#333", fontWeight: "bold", fontSize: "16px" }}>{Title}</div>
      {!loading && (!data || data.length === 0) ? (
        <NoData />
      ) : loading ? (
        <div
          className="absolute inset-0 z-10 flex items-center justify-center"
          style={{ backgroundColor: "rgba(255, 255, 255, 0.7)", height: data && data.length ? undefined : 200 }}
        >
          <Loader />
        </div>
      ) : null}
      <div ref={containerRef} className="w-full" />
    </div>
  );
}

StepGraph.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      ts: PropTypes.number.isRequired,
      s: PropTypes.number.isRequired,
      rsn: PropTypes.string,
    })
  ),
  loading: PropTypes.bool,
  dateRange: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.object])),
};

export default StepGraph;
